import { Switch } from 'antd';
import convertUtils from '@app/utils/convert.utils';
import { MergedProperty } from '../../types';

interface SwitchItemProps {
    item: MergedProperty;
    colClass: string;
    onChange: (value: string, code: string) => void;
}

const SwitchItem = ({ item, colClass, onChange }: SwitchItemProps) => {
    const switchValue = convertUtils.toBoolean(item.ps_value);

    return (
        <div className={`${colClass} col-sm-6`}>
            <div className="form-group">
                <label>
                    <h6 className="panel-title">{item.p_name}</h6>
                </label>
                <div style={{ marginBottom: '6px' }} />
                <Switch
                    defaultChecked={switchValue}
                    onChange={(checked) => onChange(`${checked}`, item.ps_code)}
                />
            </div>
        </div>
    );
};

export default SwitchItem;
